import axiosConfig from "./axiosConfig";

export interface PvReportData {
  pvPanel: {
    manufacturer: string;
    model: string;
    pnom: number;
    height: number;
    width: number;
  };
  pvInverters: Array<{
    name: string;
    manufacturer: string;
    model: string;
    ratedAcOutputPower: number;
    count: number;
  }>;
  inverterTotalPowerKwAc: number;
  lossFactorLabels: Record<string, string>;
}

const getPvReportData = async (
  authToken: string,
  siteId: string,
  userOrgId?: string
): Promise<PvReportData> => {
  const params = new URLSearchParams();
  if (userOrgId) params.append("userOrgId", userOrgId);

  const url = `/site/${siteId}/pv-report-data${params.size > 0 ? `?${params}` : ""}`;

  const { data } = await axiosConfig.get(url, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getPvReportData;
